import { ifDefined } from 'lit-html/directives/if-defined';
export const ifNotNull = value => {
  if (value === null) {
    value = undefined;
  }
  return ifDefined(value);
};
//# sourceMappingURL=directives.js.map